import StatusBadge from 'components/atoms/status-badge'
import PropTypes from 'prop-types'

const propTypes = {
  section    : PropTypes.object,
  onClickRow : PropTypes.func
}
/**
 * @param {Object} section - Cms::Homepage::Section
 * @param {Function} onClickRow - function handler for on Click Row
 */
const CmsHomepageSectionTableRow = ({
  section,
  onClickRow
}) => (

  <tr
    onClick={ () => { onClickRow(section) } }
    style={{ cursor: 'pointer' }}
  >
    <td>{ section.order }</td>
    <td className='d-flex flex-column'>
      <img
        src={ section.landscape_image_url }
        className='pb-2'
        width={ 120 }
      />
      <img
        src={ section.portrait_image_url }
        width={ 120 }
      />
    </td>
    <td className='text-wrap'>{ section.title_text }</td>
    <td>
      <StatusBadge
        color={
          section.is_active
            ? 'success'
            : 'danger'
        }
        label={
          section.is_active
            ? 'Active'
            : 'Inactive'
        }
      />
    </td>
  </tr>
)

CmsHomepageSectionTableRow.propTypes = propTypes
export default CmsHomepageSectionTableRow